import { jsxs as j, jsx as e } from "react/jsx-runtime";
import { useState as g, useEffect as A } from "react";
import { Chip as D } from "./chip.js";
import { u as F } from "./index-6a632112.mjs";
import { s as k } from "./themes-5f0b3c3d.mjs";
import { D as i } from "./index-39f84169.mjs";
import "./button.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import "react-dom";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
import "./badge.js";
import "./caretDown-8ff83493.mjs";
import "./caretUp-e6db3a6f.mjs";
import "./useWindowDimensions.js";
import "./radio.js";
import "./uniqueId-321287e8.mjs";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
import "./textInput.js";
const yt = F.div`
  display: flex;
  gap: ${k["2x"]};
  flex-wrap: wrap;
`, Ct = ({
  children: a,
  menuLists: v = [],
  menuHeader: O,
  value: n = [],
  onChange: c,
  leadingIcon: x,
  isRadio: s = !1,
  isDisabled: u,
  onBlur: y
}) => {
  const [f, C] = g(!1), [m, h] = g(n);
  A(() => {
    h(n);
  }, [n]);
  const M = (t, r) => {
    const p = s ? [r?.value] : r.map((o) => o?.value);
    h(p), c && c(t, {
      label: a,
      values: p,
      isActive: !!p.length
    });
  }, $ = (t) => t?.map(({ title: r, items: p }, o) => [
    r && /* @__PURE__ */ e(i.Title, { children: r }, `title-${o}`),
    p.map(
      ({
        label: d,
        value: l = d,
        description: w = "",
        trailingElement: S = ""
      }) => /* @__PURE__ */ e(
        i.Item,
        {
          label: d,
          value: l,
          description: w,
          trailingElement: S,
          isSelected: m.includes(l)
        },
        l
      )
    ),
    o !== t.length - 1 && /* @__PURE__ */ e(i.Divider, {}, `divider-${o}`)
  ]);
  return /* @__PURE__ */ j(
    i,
    {
      menuOpen: f,
      handleMenuOpen: (t) => C(t),
      menuHeader: O,
      onChange: M,
      type: s ? "radio" : "multiple",
      isDisabled: u,
      children: [
        /* @__PURE__ */ e(i.Control, { children: /* @__PURE__ */ e(
          D,
          {
            badgeProps: {
              value: `${m.length > 0 ? m.length : ""}`,
              size: "small",
              type: "primary",
              emphasis: "high"
            },
            leadingIcon: x,
            isRadio: s,
            isActive: m.length > 0,
            isDisabled: u,
            onClick: y,
            isOpen: f,
            children: a
          }
        ) }),
        $(v)
      ]
    }
  );
};
export {
  Ct as Filter,
  yt as FilterGroup
};
